import { IPomReportingListItem, IPomReportingPosition } from "../../../domain/reporting/pom-reporting";
import { PomReportingStatus } from "../reportings/pom-reporting-status";
import { IPomReportingListItemModel, IPomReportingListModel } from "../reportings/pom-reporting-list.model";
import { IPomReportingModel, IPomReportingPositionModel } from "../reportings/pom-reporting.model";

export class PomReportingConverter {
  public static toReportingListItem(model: IPomReportingListItemModel): IPomReportingListItem {
    return {
      contractNo: model.contractNo,
      reportingNo: model.reportingNo,
      reportingPeriodStartDate: new Date(model.reportingPeriodStartDate),
      reportingPeriodEndDate: new Date(model.reportingPeriodEndDate),
      status: model.status as PomReportingStatus,
    };
  }

  public static toReportingList(model: IPomReportingListModel): IPomReportingListItem[] {
    return model.items.map(this.toReportingListItem);
  }

  public static toPosition(model: IPomReportingPositionModel): IPomReportingPosition {
    return {
      positionNo: model.positionNo,
      itemNo: model.itemNo,
      description: model.description,
      quantity: model.quantity,
      unit: model.unit,
      unitPrice: model.unitPrice,
      weightClass: model.weightClass,
    };
  }

  public static toPositions(model: IPomReportingModel): IPomReportingPosition[] {
    return model.positions.map(this.toPosition);
  }
}
